'use strict';

const Video = {
    els: null,
    init: function () {
        Video.els = document.querySelectorAll('.f-video');
        if (typeof (tarteaucitron) === 'undefined') {
            if (Video.els && Video.els.length > 0) {
                Video.els.forEach(el => {
                    Video.managePosterNOTAC(el);
                });
            }
        } else {
            if (Video.els && Video.els.length > 0) {
                Video.els.forEach(el => {
                    Video.managePoster(el);
                });
            }
        }
    },

    managePosterNOTAC: function (el) {
        let blocVideo = el.querySelector('.c-video__player-video');
        if (blocVideo) {
            // let typeVideo = "";

            // if(blocVideo.classList.contains('youtube_player')) {
            //     typeVideo = "youtube";
            // } else if(blocVideo.classList.contains('vimeo_player')) {
            //     typeVideo = "vimeo";
            // } else if(blocVideo.classList.contains('dailymotion_player')) {
            //     typeVideo = "dailymotion";
            // }

            // if (typeVideo === "youtube") {
            //     el.querySelector('.youtube_player').innerHTML = `<iframe frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; playsinline; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="100%" height="100%" src="https://www.youtube.com/embed/${blocVideo.dataset.videoid}?rel=${blocVideo.dataset.rel}&controls=${blocVideo.dataset.controls}&showinfo=${blocVideo.dataset.showinfo}&autoplay=${blocVideo.dataset.autoplay}&mute=${blocVideo.dataset.mute}&playsinline=0&loop=${blocVideo.dataset.loop}"></iframe>`
            // } else if (typeVideo === "vimeo") {
            //     el.querySelector('.vimeo_player').innerHTML = `<iframe width="100%" height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Vimeo video player" src="https://player.vimeo.com/video/${blocVideo.dataset.videoid}?autoplay=${blocVideo.dataset.autoplay}&muted=${blocVideo.dataset.mute}&loop=${blocVideo.dataset.loop}&autopause=0&background=0"></iframe>`
            // } else if (typeVideo === "dailymotion") {
            //     el.querySelector('.dailymotion_player').innerHTML = `<iframe width="100%" height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Dailymotion video player" src="https://www.dailymotion.com/embed/video/${blocVideo.dataset.videoid}?autoplay=${blocVideo.dataset.autoplay}&muted=${blocVideo.dataset.mute}&loop=${blocVideo.dataset.loop}&queue-enable=false&ui-start-screen-info=false&ui-logo=false"></iframe>`
            // }

            blocVideo.style.display = "block";
        }


        //<div class="youtube_player c-video__player-video" data-videoid="3TBcZ9spsjc" data-width="100%" data-height="100%" data-theme="dark" data-rel="0" data-controls="1" data-showinfo="0" data-autoplay="0" data-mute="0" data-srcdoc="srcdoc" data-loop="0" data-loading="1"></div>
    },

    managePoster: function (el) {
        const poster = el.querySelector('.c-video__player-poster');
        if (poster) {
            const buttonPlay = poster.querySelector('.c-video__player-poster-play');
            buttonPlay.addEventListener('click', () => {
                poster.classList.add('hidden');
                el.querySelector('.c-video__player-video').style.display = "block";
                if (poster.dataset.typeVideo === "youtube" && tarteaucitron && tarteaucitron.state.youtube) {
                    let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '')
                    if (src.includes('?')) {
                        src += "&autoplay=1&playsinline=1"
                    }
                    else {
                        src += "?autoplay=1&playsinline=1"
                    }
                    el.querySelector('.youtube_player').innerHTML = `
                        <iframe frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; playsinline; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="100%" height="100%" src="${src}"></iframe>`
                }
                else if (poster.dataset.typeVideo === "vimeo" && tarteaucitron && tarteaucitron.state.vimeo) {
                    let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '');
                    if (src.includes('?')) {
                        src += "&autoplay=1&autopause=0"
                    }
                    else {
                        src += "?autoplay=1&autopause=0"
                    }
                    el.querySelector('.vimeo_player').innerHTML = `
                        <iframe width="100%" height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay" allowfullscreen="" title="Vimeo video player" src="${src}"></iframe>`
                }
                else if (poster.dataset.typeVideo === "dailymotion" && tarteaucitron && tarteaucitron.state.dailymotion) {
                    let src = el.querySelector('iframe').getAttribute('src').replace('autoplay=0', '').replace('muted=0', '').replace('playsinline=0', '');
                    if (src.includes('?')) {
                        src += "&autoplay=1&autopause=0"
                    }
                    else {
                        src += "?autoplay=1&autopause=0"
                    }
                    el.querySelector('.dailymotion_player').innerHTML = `
                        <iframe width="100%" height="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen=""  allow="autoplay" allowfullscreen="" title="Dailymotion video player" src="${src}"></iframe>`
                }
                else if (poster.dataset.typeVideo === "mp4") {

                }
            });
        } else {
            el.querySelector('.c-video__player-video').style.display = "block";
        }
    }
};

export default Video;